export default __webpack_public_path__ + "static/media/vova_inst.2b3bd238.jpg";